/**
 * UGC 横向视频展示模块 交互脚本
 * 放到主题的 assets/ 目录下，文件名保持 section-ugc-video-carousel.js
 *
 */
(function () {
  if (window.UgcVideoCarousel) return; // 避免重复初始化

  var initedSections = {};
  var SCROLL_EDGE_THRESHOLD = 4; // 允许的像素误差，避免因小数像素导致箭头闪烁
  var MOBILE_BREAKPOINT = 749; // 需要和 CSS 里的 @media (max-width: 749px) 保持一致
  var NATURAL_CARD_WIDTH = 220; // 需要和 CSS 里 .ugc-vc__item 的基准宽度保持一致
  var MAX_FIT_CARD_WIDTH = 300; // 视频数量很少时，单张卡片允许被撑到的最大宽度

  // 桌面端：根据视频数量 + 容器实际宽度，决定卡片是"铺满"还是"固定宽度可滑动"
  function layoutList(sectionId) {
    var list = document.getElementById('ugc-vc-list-' + sectionId);
    if (!list) return;
    var items = list.querySelectorAll('.ugc-vc__item');
    var count = items.length;
    if (count === 0) return;

    if (window.innerWidth <= MOBILE_BREAKPOINT) {
      // 移动端交给 CSS 的 40% 宽度处理，清掉桌面端可能残留的内联宽度
      for (var i = 0; i < items.length; i++) items[i].style.width = '';
      list.classList.remove('ugc-vc__list--centered');
      return;
    }

    var styles = window.getComputedStyle(list);
    var gap = parseFloat(styles.columnGap || styles.gap) || 14;
    var containerWidth = list.clientWidth;
    var neededWidth = count * NATURAL_CARD_WIDTH + (count - 1) * gap;

    if (neededWidth <= containerWidth) {
      // 放得下：让卡片平分整行宽度，边到边铺满，不再留白
      var evenWidth = (containerWidth - (count - 1) * gap) / count;
      evenWidth = Math.min(evenWidth, MAX_FIT_CARD_WIDTH);

      for (var j = 0; j < items.length; j++) {
        items[j].style.width = evenWidth + 'px';
      }

      // 如果卡片宽度被上限卡住了（视频太少），平分不出去的空间就居中显示
      var filledWidth = count * evenWidth + (count - 1) * gap;
      list.classList.toggle('ugc-vc__list--centered', filledWidth < containerWidth - 1);
    } else {
      // 放不下：恢复固定卡片宽度（跟随 CSS 默认值），走横向滚动
      for (var k = 0; k < items.length; k++) {
        items[k].style.width = '';
      }
      list.classList.remove('ugc-vc__list--centered');
    }
  }

  function updateNavState(sectionId) {
    var list = document.getElementById('ugc-vc-list-' + sectionId);
    var root = document.getElementById('shopify-section-' + sectionId);
    if (!list || !root) return;

    var prevBtn = root.querySelector('.ugc-vc__nav--prev');
    var nextBtn = root.querySelector('.ugc-vc__nav--next');
    if (!prevBtn || !nextBtn) return;

    var maxScrollLeft = list.scrollWidth - list.clientWidth;
    var isScrollable = maxScrollLeft > SCROLL_EDGE_THRESHOLD;

    // 内容放得下，不需要滚动：两个箭头都隐藏
    if (!isScrollable) {
      prevBtn.hidden = true;
      nextBtn.hidden = true;
      return;
    }

    prevBtn.hidden = list.scrollLeft <= SCROLL_EDGE_THRESHOLD;
    nextBtn.hidden = list.scrollLeft >= maxScrollLeft - SCROLL_EDGE_THRESHOLD;
  }

  // 布局 + 箭头状态一起刷新，避免两处各算一次、状态不同步
  function refresh(sectionId) {
    layoutList(sectionId);
    updateNavState(sectionId);
  }

  function openModal(sectionId, templateId) {
    var modal = document.getElementById('ugc-vc-modal-' + sectionId);
    var player = document.getElementById('ugc-vc-player-' + sectionId);
    var template = document.getElementById(templateId);
    if (!modal || !player || !template) return;

    player.innerHTML = '';
    player.appendChild(template.content.cloneNode(true));
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeModal(sectionId) {
    var modal = document.getElementById('ugc-vc-modal-' + sectionId);
    var player = document.getElementById('ugc-vc-player-' + sectionId);
    if (!modal || !player) return;

    player.innerHTML = ''; // 清空以停止视频播放
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  function init(sectionId) {
    if (initedSections[sectionId]) return;
    var root = document.getElementById('shopify-section-' + sectionId);
    var modal = document.getElementById('ugc-vc-modal-' + sectionId);
    var list = document.getElementById('ugc-vc-list-' + sectionId);
    if (!root) return;
    initedSections[sectionId] = true;

    // 点击卡片播放 / 点击箭头滚动
    root.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-ugc-trigger]');
      if (trigger) {
        var templateId = trigger.getAttribute('data-template');
        openModal(sectionId, templateId);
        return;
      }

      var navBtn = e.target.closest('[data-ugc-scroll]');
      if (navBtn && list) {
        var dir = parseInt(navBtn.getAttribute('data-ugc-scroll'), 10) || 1;
        var card = list.querySelector('.ugc-vc__item');
        var step = card ? card.offsetWidth + 14 : 240;
        list.scrollBy({ left: dir * step, behavior: 'smooth' });
      }
    });

    // 关闭弹层
    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-ugc-close]')) {
          closeModal(sectionId);
        }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal(sectionId);
    });

    // 箭头显隐 + 卡片铺满逻辑：滚动时实时刷新（用 rAF 节流，避免 scroll 事件过密）
    if (list) {
      var ticking = false;
      list.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            updateNavState(sectionId); // 滚动只影响箭头显隐，不用重新计算卡片宽度
            ticking = false;
          });
        },
        { passive: true }
      );

      // 窗口尺寸变化（比如横竖屏切换、拖动浏览器宽度、跨越移动端断点）
      // 需要重新计算卡片宽度和箭头状态
      var resizeTimer = null;
      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          refresh(sectionId);
        }, 100);
      });

      // 封面图是懒加载的，加载完成后卡片实际宽度/滚动范围才最终确定，
      // 稍微延迟一次刷新，避免图片加载完之前算出的状态不准
      window.setTimeout(function () {
        refresh(sectionId);
      }, 300);

      // 首次渲染后立即计算一次初始状态
      refresh(sectionId);
    }
  }

  window.UgcVideoCarousel = { init: init };
})();
